export const COLLECTION_NAME = 'Cumulative'
